import { text, brandText } from '@guardian/src-foundations/palette';

export const userFeedbackDefault = {
	userFeedback: {
		textSuccess: text.success,
		textError: text.error,
	},
};

export const userFeedbackBrand = {
	userFeedback: {
		textSuccess: brandText.success,
		textError: brandText.error,
	},
};
